import { LinearProgress, Tooltip } from '@mui/joy';
import classNames from 'classnames';

import { roundTo } from '@/shared/utils/helpers';

type ClassNames = {
  root?: string;
  label?: string;
  width?: string;
};

type Props = {
  color: string;
  percentage: number;
  label?: string;
  classes?: ClassNames;
  oneLine?: boolean;
  thickness?: number;
};

const DIGITS = 2;

const defaultLabelClasses = 'font-medium text-xs 2xl:text-sm';
const defaultWidthClasses = 'w-full';

const ProgressBar: React.FC<Props> = ({
  color,
  percentage,
  label,
  classes = { root: '' },
  oneLine = false,
  thickness = 12,
}) => (
  <Tooltip arrow title={`${roundTo(percentage, DIGITS)}%`}>
    <div
      className={classNames(
        'flex gap-1 2xl:gap-2',
        { 'flex-col': !oneLine, 'flex-row-reverse items-center': oneLine },
        classes.width || defaultWidthClasses,
        classes.root,
      )}
    >
      <LinearProgress determinate value={percentage} sx={{ color }} thickness={thickness} />
      {!!label && <p className={classes.label || defaultLabelClasses}>{label}</p>}
    </div>
  </Tooltip>
);

export default ProgressBar;
